import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/Logo-MS_Horizontal-2.png'


const _withScopeId = n => (_pushScopeId("data-v-636e351c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"display":"flex","flex-direction":"row","min-height":"calc(100vh - 52px)"} }
const _hoisted_2 = { class: "login-form-container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo-container",
  src: _imports_0
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { style: {"padding":"2rem"} }
const _hoisted_6 = {
  class: "input-container title_autentificare",
  style: {"text-align":"center"}
}
const _hoisted_7 = { class: "input-container" }
const _hoisted_8 = { style: {"font-size":"1.2rem"} }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "input-container" }
const _hoisted_11 = { style: {"font-size":"1.2rem"} }
const _hoisted_12 = { class: "input-container" }
const _hoisted_13 = { style: {"font-size":"1.2rem","font-weight":"bold","margin-bottom":"16px"} }
const _hoisted_14 = /*#__PURE__*/_createTextVNode()
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = { class: "btn-container" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Download")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { style: {"margin-left":"-20vw","margin-right":"auto","padding-top":"2rem"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_vue_pdf_embed = _resolveComponent("vue-pdf-embed")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_select = _resolveComponent("q-select")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "app-center-content-horizontal",
        style: _normalizeStyle(_ctx.$q.platform.is.desktop ? 'display: flex; flex-direction: row;align-items: center;' : 'display: flex; flex-direction: column;align-items: center;')
      }, _hoisted_4, 4),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('message.auth')), 1),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('message.user')), 1),
          _createVNode(_component_q_input, {
            class: "white-border",
            placeholder: _ctx.$t('message.user'),
            outlined: "",
            style: {"max-height":"7vh","font-size":"1.2rem"},
            modelValue: _ctx.user,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user) = $event)),
            onKeydown: _withKeys(_withModifiers(_ctx.focusOnPassword, ["prevent"]), ["enter"]),
            "lazy-rules": "",
            dense: "",
            autofocus: "",
            autocomplete: ""
          }, null, 8, ["placeholder", "modelValue", "onKeydown"])
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('message.password')), 1),
          _createVNode(_component_q_input, {
            placeholder: _ctx.$t('message.password'),
            outlined: "",
            style: {"max-height":"7vh","font-size":"1.2rem"},
            modelValue: _ctx.password,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
            type: _ctx.isPwd ? 'password' : 'text',
            onKeydown: _withKeys(_withModifiers(_ctx.focusOnBtnLogin, ["prevent"]), ["enter"]),
            ref: "refPassword",
            "lazy-rules": "",
            dense: "",
            rules: [val => !!val || _ctx.$t('message.enter_field')],
            autofocus: "",
            autocomplete: ""
          }, {
            append: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: _ctx.isPwd ? 'visibility_off' : 'visibility',
                class: "cursor-pointer",
                color: "black",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isPwd = !_ctx.isPwd))
              }, null, 8, ["name"])
            ]),
            _: 1
          }, 8, ["placeholder", "modelValue", "type", "onKeydown", "rules"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('message.agree_with')), 1),
          _createElementVNode("div", null, [
            _createVNode(_component_q_checkbox, {
              modelValue: _ctx.terms,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.terms) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_14,
            _createElementVNode("span", {
              style: {"text-decoration":"none","cursor":"pointer"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.generarePdfGDPR('conditii')))
            }, _toDisplayString(_ctx.$t('message.terms')), 1)
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_q_checkbox, {
              modelValue: _ctx.gdpr,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.gdpr) = $event))
            }, null, 8, ["modelValue"]),
            _hoisted_15,
            _createElementVNode("span", {
              style: {"text-decoration":"none","cursor":"pointer"},
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.generarePdfGDPR('gdpr')))
            }, _toDisplayString(_ctx.$t('message.gdpr')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_q_btn, {
            disable: !_ctx.terms || !_ctx.gdpr,
            "no-caps": "",
            label: _ctx.$t('message.login'),
            loading: _ctx.ajaxIsLoading,
            style: {"background-color":"#273233","color":"white"},
            ref: "refBtnLogin",
            onClick: _ctx.onSubmit
          }, null, 8, ["disable", "label", "loading", "onClick"])
        ])
      ]),
      _createVNode(_component_q_dialog, {
        modelValue: _ctx.fixed,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.fixed) = $event)),
        "full-width": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card, { class: "my_card" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, { class: "row items-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$q.platform.is.mobile ? 'text-h8' : 'text-h6')
                  }, _toDisplayString(_ctx.pdfTitle), 3),
                  (_ctx.$q.platform.is.desktop)
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 0,
                        "no-caps": "",
                        color: "#273233",
                        onClick: _ctx.downloadPDF,
                        icon: "download",
                        style: {"margin-left":"1rem","cursor":"pointer"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_17
                        ]),
                        _: 1
                      }, 8, ["onClick"])), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  (_ctx.$q.platform.is.mobile)
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 1,
                        "no-caps": "",
                        flat: "",
                        color: "#273233",
                        icon: "download",
                        onClick: _ctx.downloadPDF,
                        style: {"cursor":"pointer"}
                      }, null, 8, ["onClick"])), [
                        [_directive_ripple]
                      ])
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_space),
                  (_ctx.isLoadingDocument)
                    ? (_openBlock(), _createBlock(_component_q_spinner, {
                        key: 2,
                        color: "black",
                        size: _ctx.$q.platform.is.mobile ? '1.5em' : '3em'
                      }, null, 8, ["size"]))
                    : _createCommentVNode("", true),
                  (_ctx.isLoadingDocument)
                    ? (_openBlock(), _createBlock(_component_q_space, { key: 3 }))
                    : _createCommentVNode("", true),
                  (_ctx.$q.platform.is.desktop)
                    ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 4,
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: ""
                      }, null, 512)), [
                        [_directive_close_popup]
                      ])
                    : _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                        key: 5,
                        icon: "close",
                        flat: "",
                        round: "",
                        dense: "",
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.widthPdf=300))
                      }, null, 512)), [
                        [_directive_close_popup]
                      ])
                ]),
                _: 1
              }),
              (_ctx.$q.platform.is.mobile)
                ? (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 0,
                    class: "my_card_2"
                  }, {
                    default: _withCtx(() => [
                      (!_ctx.isLoadingDocument)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 0,
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.changeWitdhPdf('in'))),
                            icon: "zoom_in",
                            style: {"margin-bottom":"8px"}
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isLoadingDocument)
                        ? (_openBlock(), _createBlock(_component_q_btn, {
                            key: 1,
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.changeWitdhPdf('out'))),
                            icon: "zoom_out",
                            style: {"margin-left":"10px","margin-bottom":"8px"}
                          }))
                        : _createCommentVNode("", true),
                      _hoisted_18,
                      _createVNode(_component_vue_pdf_embed, {
                        source: _ctx.pdf,
                        width: _ctx.widthPdf
                      }, null, 8, ["source", "width"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_q_card_section, {
                    key: 1,
                    class: "my_card_2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_vue_pdf_embed, { source: _ctx.pdf }, null, 8, ["source"])
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_q_select, {
        outlined: "",
        modelValue: _ctx.selectedLang,
        "onUpdate:modelValue": [
          _cache[11] || (_cache[11] = ($event: any) => ((_ctx.selectedLang) = $event)),
          _cache[12] || (_cache[12] = val => _ctx.changeLanguage(val))
        ],
        options: _ctx.languages,
        "option-value": "id",
        "option-label": "name",
        class: "form__input",
        "emit-value": "",
        dense: "",
        "map-options": ""
      }, null, 8, ["modelValue", "options"])
    ])
  ]))
}